<template>
    <div class="question mb-4">
        <div class="mb-3">
            <div class="question__title">В приведенной ниже таблице отметьте, каких именно навыков не хватает  работникам в Вашей организации в текущий момент.</div>
            <div class="question__desc caption">Используйте шкалу от 1 до 5. (1- нет недостатка в этом навыке,  5 – данного навыка существенно не хватает, 0- отметьте, если наличие данного навыка предприятию не требуется).</div>
        </div>

        <table class="table-skills">
            <thead class="table-skills__header">
                <tr>
                    <td rowspan="2">Наименование навыков</td>
                    <td colspan="3">Уровень потребности в данном навыкена Вашем предприятии</td>
                </tr>
                <tr>
                    <td>менеджеров</td>
                    <td>специалистов</td>
                    <td>рабочих</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(id, index) in ids" v-if="index%3 === 0" :key="id">
                    <td v-if="list[id].text">{{ list[id].text }}</td>
                    <td>
                        <question-radio
                                has-index
                                :index-offset="0"
                                :isSingle="true"
                                v-if="list[ids[index]].type === 'radio' && list[ids[index]].answers.length"
                                :horizontal="!!list[ids[index]].is_horizontal"
                                :items="list[ids[index]].answers"
                                @input="$emit('sendAnswer', $event, ids[index])"
                        />
                    </td>
                    <td>
                        <question-radio
                                has-index
                                :index-offset="0"
                                :isSingle="true"
                                v-if="list[ids[index]+1].type === 'radio' && list[ids[index]+1].answers.length"
                                :horizontal="!!list[ids[index]+1].is_horizontal"
                                :items="list[ids[index]+1].answers"
                                @input="$emit('sendAnswer', $event, ids[index] + 1)"
                        />
                    </td>
                    <td>
                        <question-radio
                                has-index
                                :index-offset="0"
                                :isSingle="true"
                                v-if="list[ids[index]+2].type === 'radio' && list[ids[index]+2].answers.length"
                                :horizontal="!!list[ids[index]+2].is_horizontal"
                                :items="list[ids[index]+2].answers"
                                @input="$emit('sendAnswer', $event, ids[index] + 2)"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import QuestionRadio from '@/components/question/radio'

    export default {
        components: {
            QuestionRadio
        },
        props: {
            ids: Array
        },
        data () {
            return {
                items: [],
                value: ''
            }
        },
        computed: {
            ...mapGetters('questions', ['questions']),
            list () {
                let out = {}

                this.questions.forEach(item => {
                    out[item.id] = item
                })

                return out
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .question {
        &__title {}
        &__desc {
            color #777777
        }
    }

    .table-skills {
        width 100%
        border-collapse collapse

        &__header {
            text-align center
        }

        td {
            padding .5rem 1rem
            border 1px solid rgba(0,0,0,0.42)
        }
    }
</style>
